import { Link } from 'react-router-dom';
import { FaFacebook, FaYoutube, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const footerData = {
    contact: {
      salon: {
        title: 'Brissbella VIP Unisex Salon',
        address: 'No 303/1 William Gopallawa Mawatha, Kandy',
        phone: '+94 74 363 3914',
      },
      academyKandy: {
        title: 'Brissbella Academy',
        address: 'No. 360, 7/C Kandy - Colombo Rd, Kandy',
        address2: 'Kattiya Junction, Old Kesbewa Rd, Nugegoda',
        phone: '+94 77 662 0717',
      },
    },
    social: {
      facebook: [
        {
          name: 'Brissbella Academy',
          url: 'https://www.facebook.com/brissbellaacademy',
        },
        {
          name: 'Brissbella VIP Salon',
          url: 'https://www.facebook.com/vipsalonkandy',
        },
        {
          name: 'Brissbella Online Store',
          url: 'https://www.facebook.com/brissbellaonlinestore',
        },
      ],
      instagram: [
        {
          name: 'Brissbella Academy',
          url: 'https://www.instagram.com/brissbella.academy/',
        },
        {
          name: 'Brissbella Wellness Store',
          url: 'https://www.instagram.com/brissbella.wellness.store/',
        },
      ],
      youtube: {
        name: 'Brissbella Academy',
        url: 'https://www.youtube.com/channel/UC8RDbIoUP75tDj5Xt25Azcg',
      },
    },
  };

  return (
    <footer className="border-t border-pink-100/80 bg-gradient-to-b from-white via-pink-50/30 to-rose-50/40 pt-14 pb-8 sm:pt-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand and Description */}
          <div>
            <Link to="/" className="block mb-4">
              <img src="/images/logo.png" alt="Brissbella" className="h-8" />
            </Link>
            <p className="text-gray-600 text-sm">
              Brissbella Is Known For Luxury Meets Tranquility. We Are Engaged
              Into The Market Via Beauty Therapy, Bridal Services, Brissbella
              Academy And A Series Of Herbal Beauty Products.
            </p>
            <div className="flex space-x-4 mt-6">
              {footerData.social.facebook.map((profile) => (
                <a
                  key={profile.url}
                  href={profile.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 hover:text-primary-700"
                >
                  <FaFacebook size={24} />
                </a>
              ))}
              <a
                href={footerData.social.youtube.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 hover:text-primary-700"
              >
                <FaYoutube size={24} />
              </a>
              {footerData.social.instagram.map((profile) => (
                <a
                  key={profile.url}
                  href={profile.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 hover:text-primary-700"
                >
                  <FaInstagram size={24} />
                </a>
              ))}
            </div>
          </div>

          {/* Find It Fast */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Find It Fast</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-primary-600">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/store"
                  className="text-gray-600 hover:text-primary-600"
                >
                  Shop
                </Link>
              </li>
              <li>
                <Link
                  to="/verification"
                  className="text-gray-600 hover:text-primary-600"
                >
                  Verification
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-gray-600 hover:text-primary-600"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-600 hover:text-primary-600"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Care */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Customer Care</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/account"
                  className="text-gray-600 hover:text-primary-600"
                >
                  My Account
                </Link>
              </li>
              <li>
                <Link
                  to="/track-order"
                  className="text-gray-600 hover:text-primary-600"
                >
                  Track Your Order
                </Link>
              </li>
              <li>
                <Link
                  to="/returns"
                  className="text-gray-600 hover:text-primary-600"
                >
                  Returns/Exchange
                </Link>
              </li>
              <li>
                <Link
                  to="/faqs"
                  className="text-gray-600 hover:text-primary-600"
                >
                  FAQs
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="text-gray-600 hover:text-primary-600"
                >
                  Product Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Contact Info</h3>
            <div className="space-y-4">
              {/* VIP Salon */}
              <div>
                <p className="text-gray-900 font-medium">
                  {footerData.contact.salon.title}
                </p>
                <p className="text-gray-600 text-xs font-light">
                  {footerData.contact.salon.address}
                </p>
                <p className="text-gray-600 text-sm font-light">
                  {footerData.contact.salon.phone}
                </p>
              </div>

              {/* Academy Kandy */}
              <div>
                <p className="text-gray-900 font-medium">
                  {footerData.contact.academyKandy.title}
                </p>
                <p className="text-gray-600 text-xs font-light">
                  {footerData.contact.academyKandy.address}
                </p>
                <p className="text-gray-600 text-xs font-light">
                  {footerData.contact.academyKandy.address2}
                </p>
                <p className="text-gray-600 text-sm font-light">
                  {footerData.contact.academyKandy.phone}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Note - Centered */}
        <div className="mt-16 pt-8 border-t border-gray-200 text-center">
          <p className="text-gray-600 mb-2">
            Copyright 2022 Brissbella. All Right Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
